import './compat-setup'
import { createApp, ref } from 'vue'
import App from './App.vue'
import router from './router'

import VueAxios from 'vue-axios'
import VCalendar from 'v-calendar';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import config from "@lib/frontend/config";
import xhr from "@lib/frontend/xhr";
import * as composable from "@lib/frontend/composable"

console.log("ENV", process.env)
console.log("CONFIG", config)

const user = composable.useUser()

async function boot() {

  const app = createApp(App)
  app.config.warnHandler = () => { }; // Disabled Warnings at app level

  // Standard Vue 3 way to provide global properties
  app.config.globalProperties.$xhr = xhr
  app.use(VueAxios, xhr)

  // Only use BootstrapVue once to avoid duplicate registration warnings
  app.use(BootstrapVue)
  app.use(IconsPlugin)
  app.use(router)
  app.use(VCalendar, {})

  if (localStorage.getItem('jwt')) {
    try {
      await user.loginJwt(localStorage.getItem('jwt'))
    } catch (e) {
      console.error("Cached login failed, jwt invalid", e)
    }
  }

  router.beforeEach((to, from) => {
    if (to.name == 'login' || to.name == 'home') {
      return true
    }
    if (!user.profile.value) {
      console.log("Login required")
      return { name: 'login' }
    }

    if (to.name === 'LFO_Prize_Wheel' && user.profile.value?.role?.name === 'Authenticated') {
      return { name: 'home' }
    }

    return true
  })

  app.provide('user', user)
  app.provide('config', config)
  app.mount('#app')
}


boot()
  .then(() => {
    console.log("BOOTED");
    // Register Service Worker for Offline Support only for LFO route/user
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        const swPath = `${process.env.BASE_URL || '/'}sw.js`;
        const isLFORoute = window.location.hash.includes('/LFO');
        const isLFOUser = user.profile.value?.role?.name === 'LFO';

        if (isLFORoute || isLFOUser) {
          console.log('[SW] LFO detected, registering:', swPath);
          navigator.serviceWorker.register(swPath)
            .then((registration) => {
              console.log('[SW] Registered successfully:', registration.scope);
            })
            .catch((err) => {
              console.error('[SW] Registration failed:', err);
            });
        } else {
          // Unregister SW for other routes to prevent any caching interference
          navigator.serviceWorker.getRegistrations().then((registrations) => {
            for (let registration of registrations) {
              registration.unregister();
              console.log('[SW] Unregistered to prevent interference with other modules');
            }
          });
        }
      });
    }
  })
  .catch((e) => console.error("BOOT ERROR", e))


